import { useEffect, useState } from 'react'
import { useI18n } from '@muse/i18n'
import { useNavigate } from '@muse-web/router'
import { SearchBar } from '../components/search-bar'
import { ROUTES } from '../constants/routes'

// Submit navigates to the catalog with the query; live suggestions are deferred (no suggestions API yet).
export const SearchContainer = () => {
    const { t } = useI18n()
    const navigate = useNavigate()
    const [value, setValue] = useState('')
    const [isMobileOpen, setMobileOpen] = useState(false)

    // The mobile toggle only exists < 768; collapse the expanded state when the viewport grows past
    // it so the desktop input isn't left in the flex-grown mobile layout.
    useEffect(() => {
        const query = window.matchMedia('(min-width: 768px)')
        const collapseOnDesktop = () => {
            if (query.matches) {
                setMobileOpen(false)
            }
        }
        query.addEventListener('change', collapseOnDesktop)

        return () => query.removeEventListener('change', collapseOnDesktop)
    }, [])

    const handleChange = (next: string) => {
        setValue(next)
    }

    const handleMobileOpen = () => {
        setMobileOpen(true)
    }

    const handleMobileClose = () => {
        setMobileOpen(false)
    }

    const handleSubmit = () => {
        const text = value.trim()

        if (text) {
            const params = new URLSearchParams({ search_text: text, sort: 'relevance' })
            const url = `${ROUTES.catalog}?${params.toString()}`

            navigate(url)
            setValue('')
            setMobileOpen(false)
        }
    }

    return (
        <SearchBar
            value={value}
            searchLabel={t('i18n.headerSearch')}
            submitLabel={t('i18n.headerSubmitSearch')}
            isMobileOpen={isMobileOpen}
            onChange={handleChange}
            onSubmit={handleSubmit}
            onMobileOpen={handleMobileOpen}
            onMobileClose={handleMobileClose}
        />
    )
}
